const IGNORED_NETWORK_ERROR_PATTERNS = [
  /^(?:[A-Za-z]+Error:\s*)?Failed to fetch$/i,
  /NetworkError/i,
  /^(?:[A-Za-z]+Error:\s*)?Load failed$/i,
  /Network request failed/i
];

export type NetworkErrorLike = Partial<{
  message: string;
  name: string;
  type: string;
}>;

/**
 * Returns true if any of the error's message/name/type fields match a known noisy
 * network-error pattern. Checking multiple fields is needed because the keyword isn't always
 * in the message - e.g. some third-party network failures only surface "NetworkError" as the
 * error type, not in the message text.
 */
export const isIgnoredNetworkError = (error: NetworkErrorLike | null | undefined): boolean => {
  if (!error) {
    return false;
  }

  return [error.message, error.name, error.type].some(
    (value) =>
      Boolean(value) && IGNORED_NETWORK_ERROR_PATTERNS.some((pattern) => pattern.test(value ?? ''))
  );
};
